/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useSelector } from 'react-redux';
import SavableTextAreaField from '../../components/SavableTextAreaField';
import { cancelSubjectEdit, saveSubject, startSubjectEdit } from '../../actions/TicketActions';
import { useAppDispatch, useAppSelector } from '../../reducers/zorseGrrTagging';
import { jsx as _jsx } from "react/jsx-runtime";
function handleTextTyped(dispatch, ticket) {
  return newSubject => {
    if (newSubject && ticket.subject !== newSubject) {
      dispatch(saveSubject(ticket.id, newSubject));
    }
  };
}
function TicketSubjectField() {
  const dispatch = useAppDispatch();
  const isSaving = useAppSelector(({
    zorseGrrTagging: state
  }) => state.actionStates.isSavingSubject);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseGrrTagging' does not exist on type ... Remove this comment to see the full error message
  const ticket = useSelector(({
    zorseGrrTagging: state
  }) => state.ticket);
  return /*#__PURE__*/_jsx(SavableTextAreaField
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'undefined... Remove this comment to see the full error message
  , {
    helpLangPath: "app.panel.body.fields.help.ticketSubject",
    isRequired: true,
    isSaving: isSaving,
    labelLangPath: "app.panel.body.fields.labels.ticketSubject",
    onCancelledEditing: () => dispatch(cancelSubjectEdit()),
    onStartedEditing: () => dispatch(startSubjectEdit()),
    onTextTyped: handleTextTyped(dispatch, ticket),
    placeholderLangPath: "app.panel.body.fields.placeholders.choose",
    value: ticket.subject && ticket.subject || ''
  });
}
export default TicketSubjectField;